import Observer from "zen-observable"
import {User, Business} from "@irati/types"
import ObserveWithPriority from "@irati/auth/helpers/auth/ObserveWithPriority"
import InternalAuth from "@irati/auth-internal/streams/auth"
import AuthedStream from "@irati/auth/streams/auth"
import UnauthedStream from "@irati/auth/streams/unauthed"
import GlobalStream from "@irati/auth/streams/global"
import authentication from "@irati/auth"
import {PLATFORM} from "../../platform"
import platform from "./platform"

interface AuthLike {
  user?: User,
  business?: Business,
  branding?: any
}

class MixpanelCommon {
  user?: User
  business?: Business
  observers: ZenObservable.SubscriptionObserver<AuthLike>[] = []

  constructor() {
    new ObserveWithPriority<AuthLike>({streams: [AuthedStream, UnauthedStream, InternalAuth, GlobalStream], key: "branding"})
      .subscribe((data) => {
        this.user = data.user
        this.business = data.business

        this.observers.forEach((observer) => {
          observer.next({user: this.user, business: this.business})
        })

        if (authentication.isUserGhost()) {
          platform.setAsGhostSession()
        }
      })
  }

  get stream() {
    return new Observer<AuthLike>((observer) => {
      this.observers.push(observer)

      return () => {
        this.observers = this.observers.filter((t) => t !== observer)
      }
    })
  }

  getDefaultAttributes() {
    return {
      user_id: this.user?.uuid,
      tenant_locale: this.user?.locale,
      tenant_id: this.user?.businessId,
      tenant_grouping: this.business?.groupId,
      tenant_subdomain: this.business?.subdomain,
      tenant_public_name: this.business?.businessName,
      perkbox_platform: PLATFORM
    }
  }

  trackEvent(name: string, dataAttributes: any) {
    const eventDefaultAttributes = this.getDefaultAttributes()
    return platform.trackEvent(name, {...eventDefaultAttributes, ...dataAttributes})
  }

  setup(env: string) {
    return platform.setup(env)
  }
}

const mixpanel = new MixpanelCommon()
export default mixpanel

let isLoggedIn = false
mixpanel.stream.subscribe((data) => {
  if (data.user && !isLoggedIn) {
    isLoggedIn = true
    platform.handleLogin(mixpanel.getDefaultAttributes())
  } else if (!data.user && isLoggedIn) {
    isLoggedIn = false
    platform.handleLogout()
  }
})
